<template lang="pug">
  footer.footer.mt-auto.py-3.px-3(:class='sessionGetDisplayClass(["footer", "content"])')
    .container-fluid
      .row.no-gutters.justify-content-center.justify-content-sm-start
        .col-xs-12.px-3.mb-3
          img(src='@assets/img/uh-system-logo-center.svg', width='100px', alt='University of Hawaii Logo')
        .col-xs-12.align-self-center
          div Institutional Research, Analysis & Planning Office
            div Information Technology Center ‧ 2520 Correa Road, 5th Floor ‧ HONOLULU ‧ HI ‧ 96822
            div irapo@hawaii.edu ‧ (808) 956-7532 ‧ Fax: (808) 956-9870
            div Hours: MONDAY - FRIDAY, 7:45 AM to 4:30 PM HST (Excluding Holidays)
            div
            p
            p Use of this site implies consent with our&nbsp;
              ExternalLink(href="https://www.hawaii.edu/infotech/policies/itpolicy.html", title="UH Usage Policy info") Usage Policy
              router-link.hand.ml-3(to='/aboutUs', @click.native='scrollToTop') About Us
</template>

<script>
import { mapGetters } from 'vuex';
import ExternalLink from '@components/ExternalLink';

export default {
  name: 'Footer',
  components: {
    ExternalLink
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters('session', [
      'sessionGetDisplayClass'
    ]),
  },
  methods: {
    scrollToTop: function () {
      $('html,body').scrollTop(0);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import '../assets/app.styl'
  .footer
    background-color dark-background-color
    color white
  .footer a
    color white
    text-decoration underline
</style>
